import React, { useContext, useEffect, useRef, useState } from "react";
import "../../../assets/css/gcstudent/bookCard/BookCard.css";
import AppContext from "../../../context/AppContext";

const BookCard = ({ book, index, onClick }) => {
  const [visible, setVisible] = useState(false);
  const {baseUrlForFiles}  = useContext(AppContext);
  const ref = useRef(null);

  useEffect(() => {
    if (!book) return; // guard inside hook
    const obs = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.1 }
    );
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, [book]);

  // Guard after all hooks
  if (!book) return null;

  const imgSrc = book.img
    ? `${baseUrlForFiles}/${book.img}`
    : null;

  const totalCopies = book.total_copies ?? 0;
  // Fall back to totalCopies only if backend hasn't sent available_copies yet
  const availableCopies = book.available_copies ?? totalCopies;

  return (
    <div
      ref={ref}
      className={`gcStudent-book-card ${visible ? "gcStudent-card-visible" : ""}`}
      style={{ transitionDelay: `${(index % 4) * 0.1}s` }}
      onClick={() => onClick(book)}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => e.key === "Enter" && onClick(book)}
    >
      <div className="gcStudent-book-img-wrap">
        {imgSrc ? (
          <img
            src={imgSrc}
            alt={book.title}
            className="gcStudent-book-img"
            onError={(e) => { e.target.style.display = "none"; }}
          />
        ) : (
          <div className="gcStudent-book-img-placeholder">
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" strokeWidth="1.4" strokeLinecap="round">
              <path d="M4 19.5A2.5 2.5 0 016.5 17H20"/>
              <path d="M6.5 2H20v20H6.5A2.5 2.5 0 014 19.5v-15A2.5 2.5 0 016.5 2z"/>
            </svg>
          </div>
        )}
      </div>

      <div className="gcStudent-book-info">
        <span className="gcStudent-book-badge">{book.dept || "General"}</span>
        <h5 className="gcStudent-book-title">{book.title}</h5>
        <p className="gcStudent-book-author">{book.author}</p>
        <span className={`gcStudent-book-avail ${
          availableCopies === 0 ? "gcStudent-avail-none" : "gcStudent-avail-yes"
        }`}>
          {availableCopies}/{totalCopies} Available
        </span>
      </div>
    </div>
  );
};

export default BookCard;